import { api } from 'config'

export const USER_URL = {
   login: `${api.public}v1/admin/login`,
   refresh_token: `${api.public}v1/admin/refresh`,
   logout: `${api.public}v1/admin/logout`
}
